// utils/customImageLoader.js - Simplified loader for Cloudinary and direct URLs
export default function customImageLoader({ src, width, quality = 75 }) {
  // Handle base64/data URLs - return immediately without processing
  if (src && src.startsWith('data:')) {
    return src;
  }

  // Ensure width is provided for Next.js Image component compatibility
  if (!width) {
    console.warn('Width not provided to customImageLoader, using default 800px');
    width = 800;
  }

  // Handle relative paths that start with /uploads - direct access to API
  if (src.startsWith('/uploads/')) {
    const baseUrl = process.env.NEXT_PUBLIC_API_URL || 'https://us-central1-fenparet-website.cloudfunctions.net/api';
    const separator = src.includes('?') ? '&' : '?';
    return `${baseUrl}${src}${separator}w=${width}&q=${quality}`;
  }

  // For backend URLs, add optimization parameters
  if (src.includes('us-central1-fenparet-website.cloudfunctions.net') ||
      src.includes('localhost:5000')) {
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}w=${width}&q=${quality}`;
  }

  // For Cloudinary images, use their optimization parameters
  if (src.includes('res.cloudinary.com')) {
    // Parse cloudinary URL and add optimization params
    let cloudinaryOptimized = src;
    
    // Add transformations if they don't already exist
    if (!src.includes('/w_') && !src.includes('/q_')) {
      if (src.includes('/image/upload/')) {
        cloudinaryOptimized = src
          .replace('/image/upload/', `/image/upload/w_${width},q_${quality},f_auto,c_limit/`);
      } else if (src.includes('/upload/')) {
        cloudinaryOptimized = src
          .replace('/upload/', `/upload/w_${width},q_${quality},f_auto,c_limit/`);
      } else {
        // For direct Cloudinary URLs, add transformations before the public_id
        const urlParts = src.split('/');
        const uploadIndex = urlParts.indexOf('upload');
        if (uploadIndex > 0 && uploadIndex < urlParts.length - 1) {
          urlParts.splice(uploadIndex + 1, 0, `w_${width},q_${quality},f_auto,c_limit`);
          cloudinaryOptimized = urlParts.join('/');
        }
      }
    }
    
    return cloudinaryOptimized;
  }

  // For local static assets, return as-is (width handled by Next.js)
  if (src.startsWith('/images/') || src.startsWith('/icons/') || src.startsWith('/favicon')) {
    return src;
  }

  // Replace problematic placeholder services with local fallback
  if (src.includes('via.placeholder.com') || 
      src.includes('placeholder.com') ||
      src.includes('picsum.photos')) {
    return '/images/placeholder.png';
  }

  // For external CDN images that support query parameters
  if (src.includes('unsplash.com') || src.includes('images.unsplash.com')) {
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}w=${width}&q=${quality}&fit=crop&auto=format`;
  }

  // For other external images, return as-is
  if (src.startsWith('http://') || src.startsWith('https://')) {
    return src;
  }

  // For other local paths, return as-is
  return src;
}